var _path, _path2, _ellipse, _ellipse2, _ellipse3, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1Faa3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#88C9F9",
    d: "M3 9l4.786 23.182S10 35 18 35s10.214-2.818 10.214-2.818L33 9H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B88C3",
    d: "M2 5h32v4H2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3B88C3",
    cx: 18,
    cy: 9.042,
    rx: 16,
    ry: 3.958
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#55ACEE",
    cx: 18,
    cy: 5,
    rx: 16,
    ry: 4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#004A77",
    cx: 18,
    cy: 4.625,
    rx: 15,
    ry: 3.375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M18 26.413C8.406 26.413.602 18.489.602 8.75c0-.552.448-1 1-1s1 .448 1 1c0 8.637 6.908 15.663 15.398 15.663 8.491 0 15.398-7.026 15.398-15.663 0-.552.447-1 1-1s1 .448 1 1c0 9.739-7.804 17.663-17.398 17.663z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M25.406 23.826C25.406 25.579 22.09 27 18 27s-7.406-1.421-7.406-3.174 2.116 0 7.406 0 7.406-1.753 7.406 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Faa3);
export default __webpack_public_path__ + "static/media/1faa3.3639f10411b779096eb0122619bf9fd4.svg";
export { ForwardRef as ReactComponent };